import React, { useContext, useState } from "react";
import "./Product_Info_List_View.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBasketShopping,
  faHeart,
  faSortDown,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";

// import IncrementDecrementBtn from '../Increment_Decrement_Btn/Increment_Decrement_Btn'
import { useNavigate } from "react-router-dom";
import Red_Outline_Btn from "../../Common-Component/common_btn/red_outline_btn/Red_Outline_Btn";
import Green_Btn from "../../Common-Component/common_btn/green_btn/Green_Btn";
import Blue_Btn from "../../Common-Component/common_btn/blue_btn/Blue_Btn";
import SupermarketModal from "../../Common_modal/Supermarket-modal/SupermarketModal";
import Add_Cart_Modal from "../../Common_modal/add_cart_modal/Add_Cart_Modal";
import { Context } from "../../../utils/context";
import { addWishlist } from "../../../utils/apis/Wishlist/Wishlist";
import { encodeId } from "../../../utils/common";
import Login_Modal from "../../Common_modal/login_modal/Login_Modal";

const Product_Info_List_View = ({
  prodname,
  image,
  selling_price,
  mrp,
  discount,
  showQty,
  product,
  product_id,
  variant_id,
}) => {
  const navigate = useNavigate();

  const [favouriteProduct, setFavouriteProduct] = useState();
  const [addCartModal2, setAddCartModal2] = useState(false);
  const [showIncrement, setShowIncrement] = useState(false);

  const {
    shimmerLoader,
    setShimmerLoader,
    addCartModal,
    setAddCartModal,
    wishlistData,
    wishlistContext,
    triggerCartUpdate,
    signin,
  } = useContext(Context);

   const handleHeartClick = async (data) => {
    // setShimmerLoader(true);
    if (signin) {
      const res = await addWishlist(data);
      if (res?.success) {
        wishlistContext();
      }
      setShimmerLoader(false);
    } else {
      setShimmerLoader(false);
      setModalLShow(true);
      setCount((count) => count + 1);
      // navigate("/login");
    }
  };

  const [modalLShow, setModalLShow] = useState(false);
  const [count, setCount] = useState(0);

  return (
    <section className="Product_Info_List_View">
      <div className="wishlist_cart_holder">
        <div
          className="left_side"
          onClick={() => navigate(`/vendor-page/${encodeId(product_id)}`)}
        >
          <div className="img_holder">
            <img src={image} />
          </div>
        </div>

        <div className="right_side">
          <div className="footer_div">
            <div className="footer_left_side">
              <div
                className="product_name"
                onClick={() => navigate(`/vendor-page/${encodeId(product_id)}`)}
              >
                <p>{prodname}</p>
              </div>

              <div className="price_section">
                <div className="selling_price">
                  <p>₹ {selling_price}</p>
                </div>

                <div className="mrp">
                  <p>₹ {mrp}</p>
                </div>

              </div>

            </div>

            <div className="footer_right_side">
              <div className="footer_btn_holder">
                <div
                  className="kilo_main_div"
                  onClick={() => {
                    // setShowIncrement(true);
                    navigate(`/vendor-page/${encodeId(product_id)}`);
                  }}
                >
                  <div className="kilo_div">
                    <div>
                      <p className="kilo_text">
                        {" "}
                        {product?.product_variants?.[0]?.v_name} {product?.unit}
                      </p>
                    </div>
                    {/* <div>
                      <FontAwesomeIcon
                        icon={faSortDown}
                        className="down_icon"
                      />
                    </div> */}
                  </div>
                </div>
                <div className="btn_holder">
                  {!product?.outofstock ? (
                    <>
                      {!showIncrement ? (
                        <div className="">
                          <Blue_Btn
                            btn_name="Add to Cart"
                            leftIcon={faBasketShopping}
                            onClick={() => {
                              // setShowIncrement(true);
                              navigate(`/vendor-page/${encodeId(product_id)}`);
                            }}
                          />
                        </div>
                      ) : (
                        <div className="">
                          {/* <IncrementDecrementBtn /> */}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="">
                      <Red_Outline_Btn btn_name="Out of Stock" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rating_div">
          <div
            className="heart_div"
            onClick={(e) => {
              e.stopPropagation();
              handleHeartClick({
                product_id: product_id,
                variant_id: variant_id,
              });
            }}
          >
            <FontAwesomeIcon
              icon={faHeart}
              // className={`heart_icon ${
              //   prodname == favouriteProduct ? "deactive" : ""
              // }`}

              className={
                wishlistData?.some((item) => item.product_id === product_id)
                  ? "heart_icon active"
                  : "heart_icon "
              }
            />
          </div>
        </div>

        {discount && (
          <div className="text_div">
            <div className="discont_div">
              <p className="discount_text">{discount}% Off</p>
            </div>
          </div>
        )}
      </div>

      <Add_Cart_Modal
        show={addCartModal2}
        onHide={() => setAddCartModal2(false)}
      />

       <Login_Modal
        key={count}
        show={modalLShow}
        onHide={() => setModalLShow(false)}
      />
    </section>
  );
};

export default Product_Info_List_View;
